module.exports = __webpack_public_path__ + "img/schemeList09-1.801b6a66.png";